import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Lucas, 19 años',
    text: 'Juego en la liga local y siempre me costaba el retroceso. Con el manual aprendí a perfilarme y ahora me pasan mucho menos.'
  }, {
    name: 'Martín, 24 años',
    text: 'Pensé que era solo teoría, pero los ejemplos son re prácticos. El bono de preparación física me vino de diez.'
  }, {
    name: 'Valentina, 21 años',
    text: 'Juego de 4 y me sirvió muchísimo para entender cuándo pasar al ataque sin dejar regalada a mi central.'
  }, {
    name: 'Agustín, 16 años',
    text: 'Mi técnico me pedía que juegue por dentro y no entendía cómo. El capítulo 5 me aclaró todo el panorama.'
  }, {
    name: 'Diego, 28 años',
    text: 'Juego torneos amateurs los findes. Aplicar lo de los centros al primer palo me hizo dar 3 asistencias en los últimos 2 partidos.'
  }];
  return <section className="py-16 px-4 bg-white" data-id="element-134">
      <div className="max-w-4xl mx-auto" data-id="element-135">
        <h2 className="text-3xl text-center text-[#1a3d1f] mb-10 uppercase font-bold" style={{
        fontFamily: 'Anton, sans-serif'
      }} data-id="element-136">
          Más laterales que ya mejoraron su juego
        </h2>

        <div className="grid md:grid-cols-2 gap-4" data-id="element-137">
          {testimonials.map((test, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className={`bg-[#f8f9fa] p-5 rounded-xl border border-gray-100 ${index === 4 ? 'md:col-span-2 md:w-1/2 md:mx-auto' : ''}`} data-id="element-138">
              <div className="flex text-[#84cc16] mb-2" data-id="element-139">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-140" />)}
              </div>
              <p className="text-gray-700 italic mb-2 text-sm" data-id="element-141">"{test.text}"</p>
              <p className="font-bold text-[#1a3d1f] text-sm" data-id="element-142">{test.name}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}